import React, { useEffect, lazy, Suspense, useState } from "react";
import Headerr from "./Headerr";
import "../../../assets/css/About.css";
import Applestore from "../../../assets/img/appstore.png";
import GooglePlay from "../../../assets/img/playstor.png";
import Frame from "../../../assets/img/Frame-4-7-scaled.png";
import TestimonialSlider from "../../Slider/TestimonialSlider"
import FAQ from "../../Blog/FAQ";
import phonees from "../../../assets/img/RentelPost.png"
import Frame3 from "../../../assets/img/Frame3.png";
import { FiPieChart } from "react-icons/fi";
import { BsCloudArrowDown } from "react-icons/bs";
import { VscGraph } from "react-icons/vsc";
import { AiOutlineSafetyCertificate } from "react-icons/ai";
import Mask from "../../../assets/img/Mask1.png";
import mobill from "../../../assets/img/3mobill-1.png";
import Earn from "../../../assets/img/3d-wallet.png";
import Spend from "../../../assets/img/credit-card.png";
import Faster from "../../../assets/img/power.png";
import Instant from "../../../assets/img/speech-bubble.png"
import NoCopyWrapper from "../../../utils/NoCopyWrapper";
import NoZoomWrapper from "../../../utils/NoZoomWrapper";
import appStoreImg from "../../../assets/img/appstore.png"
import { FaCreditCard } from "react-icons/fa6";
import playStoreImg from "../../../assets/img/playstor.png"
import banner2 from "../../../assets/img/Why-BuyJust-Rent-(9).png"
import StickyBottomNav from "../../StickyBottomNav/StickyBottomNav";
import halfphone from "../../../assets/img/RentelPost.png"
// Lazy-loaded components
const PhoneSlider = lazy(() => import("./PhoneSlider"));
const PhoneSwiper = lazy(() => import("./PhoneSwiper"));
const Testimonial = lazy(() => import("./Testimonial"));
const Footer = lazy(() => import("../Footer"));

const About = () => {
  const [readMore, setReadMore] = useState(false);          // Earn Easily
  const [readMoreSpend, setReadMoreSpend] = useState(false);
  const [readMoreFaster, setReadMoreFaster] = useState(false);  // Rent Faster
    const [readMoreChat, setReadMoreChat] = useState(false); 
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <NoZoomWrapper>
      <NoCopyWrapper>
        <Headerr />

        <section className="about-section">
          <h1 className="about-title">
            Your <span className="highlight">Trusted</span> Rentel Platform
          </h1>

          {/* <p className="about-desc">
            Rent or lend anything clothes, gadgets, vehicles & more. Save big,
            earn easy, and enjoy hassle-free rentals! 🚀
          </p> */}

          {/* Store Buttons */}
          <div className="store-buttonsj">
            <a
              href="https://apps.apple.com/in/app/rentel-rent-smart-live-better/id6744444463"
              className="store-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={Applestore}
                alt="Apple Store"
                className="store-icon"
                loading="lazy"
              />
            </a>

            <a
              href="https://play.google.com/store/apps/details?id=com.rent.el.in"
              className="store-btn"
            >
              <img
                src={GooglePlay}
                alt="Google Play"
                className="store-icon"
                loading="lazy"
              />
            </a>
          </div>

          {/* PhoneSlider Lazy Load */}
          {/* <Suspense fallback={<div>Loading...</div>}>
            <PhoneSlider />
          </Suspense> */}
          <Suspense fallback={<div>Loading...</div>}>
            {/* <PhoneSwiper /> */}
            {/* <img src={halfphone} style={{width:"100%"}} /> */}
            <div />
          </Suspense>
        </section>


        <section className="about-bannerrs">
          <div className="about-bannerrs-wrapper">

            {/* Red gradient background */}
            <div className="about-bannerrs-card">

              <div className="about-bannerrs-info left">
                <div className="about-bannerr-info-card">
                  <div className="about-bannerr-info1-card1-img" >
                    <img src={Earn} className="about-bannerrs-info-icons" />
                  </div>

                  <div className="about-bannerr-info1-card1-text">
                    <h3>Earn Easily</h3>

                    <p className={readMore ? "full-text" : "short-text"}>
                      List your unused items and start earning money with every successful rental.
                    </p>

                    <span
                      className="read-more-btn"
                      onClick={() => setReadMore(!readMore)}
                    >
                      {readMore ? "Read Less" : "Read More"}
                    </span>
                  </div>

                </div>

                <div className="about-bannerr-info-card">
                  <div className="about-bannerr-info1-card1-img" >
                    <img src={Spend} className="about-bannerrs-info-icons" />
                  </div>
                  <div className="about-bannerr-info1-card1-text">
                    <h3>Spend Less</h3>

                    <p className={readMoreSpend ? "full-text" : "short-text"}>
                      Rent what you need at affordable prices instead of buying expensive items.
                    </p>

                    <span
                      className="read-more-btn"
                      onClick={() => setReadMoreSpend(!readMoreSpend)}
                    >
                      {readMoreSpend ? "Read Less" : "Read More"}
                    </span>
                  </div>

                </div>
              </div>

              <div className="about-bannerrs-info right">
                <div className="about-bannerr-info-card">
                  <div className="about-bannerr-info1-card1-img" >
                    <img src={Faster} className="about-bannerrs-info-icons" />
                  </div>
                  <div className="about-bannerr-info1-card1-text">
                    <h3>Rent Faster</h3>

                    <p className={readMoreFaster ? "full-text" : "short-text"}>
                      Find, book, and rent items quickly without long processes or delays.
                    </p>

                    <span
                      className="read-more-btn"
                      onClick={() => setReadMoreFaster(!readMoreFaster)}
                    >
                      {readMoreFaster ? "Read Less" : "Read More"}
                    </span>
                  </div>
                </div>

                <div className="about-bannerr-info-card">
                  <div className="about-bannerr-info1-card1-img" >
                    <img src={Instant} className="about-bannerrs-info-icons" />
                  </div>
                  <div className="about-bannerr-info1-card1-text">
                    <h3>Instant Chat</h3>

                    <p className={readMoreChat ? "full-text" : "short-text"}>
                      Chat instantly with item owners to clarify details and confirm rentals.
                    </p>

                    <span
                      className="read-more-btn"
                      onClick={() => setReadMoreChat(!readMoreChat)}
                    >
                      {readMoreChat ? "Read Less" : "Read More"}
                    </span>
                  </div>

                </div>
              </div>
            </div>

            {/* Phone */}
            <img src={phonees} className="about-bannerrs-phone" style={{ display: "block" }} />

          </div>
        </section>



        {/* PhoneSwiper + Testimonial Lazy Load */}

        <Suspense fallback={<div>Loading...</div>}>
          <TestimonialSlider />
        </Suspense>

        <section className="feature-section">
          <div className="container">
            <div className="about-main">
              <div className="feature-content">
                <span className="tagline">Why You Choose Our App</span>
                <h2>
                  The Most Effective App for <br /> Your Future Projects
                </h2>
                <p>
                  Rentel offers secure, affordable, and hassle-free rentals,
                  letting you rent or lend anything—save money, earn extra, and
                  live smarter! 🚀
                </p>

                <ul className="feature-list">
                  <li>
                    From clothes and electronics to vehicles and clinical tools.
                  </li>
                  <li>
                    List your unused items and start making money effortlessly
                  </li>
                  <li>Verified users, secure payments</li>
                  <li>
                    Easy search, flexible rental periods, and doorstep delivery
                    options
                  </li>
                  <li>Reduce waste and promote a sustainable sharing economy.</li>
                </ul>

                <div className="feature-buttons">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.rent.el.in"
                    className="btn-primary"

                  >
                    Download Now
                  </a>
                </div>
              </div>

              <div className="feature-image">
                <img
                  src={Mask}
                  alt="Phone 1"
                  loading="lazy"
                  style={{ width: "100%", display: "block" }}
                />
              </div>
            </div>
          </div>
        </section>

        <FAQ limit={6} showLayout={false} />

        <section className="download-section">
          <div className="container">
            {/* ===== DESKTOP BANNER ===== */}
            <div className="rent-banner desktop-banner">
              <div className="inside-banner">
                <div className="rent-overlay">
                  <div className="rent-text">
                    <h2>
                      Why Buy?
                      <br />
                      Just Rent!
                    </h2>
                  </div>

                  <div className="rent-divider"></div>

                  <div className="rent-right">
                    <p>Download on Android & iOS</p>

                    <div className="store-index-buttons">
                      <a href="https://apps.apple.com/in/app/rentel-rent-smart-live-better/id6744444463" target="_blank"> <img src={appStoreImg} alt="App Store" /></a>
                      <a href="https://play.google.com/store/apps/details?id=com.rent.el.in" target="_blank"> <img src={playStoreImg} alt="Play Store" /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ===== MOBILE BANNER ===== */}
            <div className="mobile-bannera">
              <img src={banner2} alt="Banner" className="don2" />

              <div className="rent-overlay-mobile">
                <h2>
                  Why Buy?
                  <br />
                  Just Rent!
                </h2>

                <p>Download on Android & iOS</p>

                <div className="store-buttonsh">
                  <a href="https://apps.apple.com/in/app/rentel-rent-smart-live-better/id6744444463" target="_blank"><img src={appStoreImg} alt="App Store" className="isoapp" /></a>
                  <a href="https://play.google.com/store/apps/details?id=com.rent.el.in" target="_blank"><img src={playStoreImg} alt="Play Store" className="isoapp" /></a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Footer Lazy Load */}
        <Suspense fallback={<div>Loading...</div>}>
          <Footer />
        </Suspense>
        <StickyBottomNav />
      </NoCopyWrapper>
    </NoZoomWrapper>
  );
};

export default About;
